import { LucideIcon, PhoneIcon } from 'lucide-react';

import { EmailIcon } from '@/components/atoms/Icons/EmailIcon';
import Infobip from '@/components/atoms/Icons/Infobip';
import Viber from '@/components/atoms/Icons/Viber';
import Whatsapp from '@/components/atoms/Icons/Whatsapp';
import { FilterOption } from '@/components/ui/custom/ComplexFilter/types';

export const SORT_FIELD_MAP: Record<string, string> = {
  email: 'email',
  phone: 'phone',
  sent: 'last_sent_at',
  delivered: 'last_delivered_at',
  read: 'last_read_at',
  replied: 'last_replied_at',
};

export const CHANNEL_OPTIONS: FilterOption[] = [
  { label: 'WhatsApp', value: 'whatsapp', icon: Whatsapp as unknown as LucideIcon },
  { label: 'Viber', value: 'viber', icon: Viber as unknown as LucideIcon },
  { label: 'SMS', value: 'sms', icon: Infobip as unknown as LucideIcon },
  { label: 'RCS', value: 'rcs', icon: Infobip as unknown as LucideIcon },
  { label: 'Email', value: 'email', icon: EmailIcon as unknown as LucideIcon },
  { label: 'Voice', value: 'voice', icon: PhoneIcon },
];
